import { FC } from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { createCustomerPageSelectors, getSelectorAttribute } from '@vy/app-selectors';
import { AddIcon } from '../../../../../../components/icons/AddIcon';
import { Pen, VyIcon } from '@vy/ui-design-system';

type CreateCustomerContactsManagementControlsProps = {
  handleAddContact: () => void;
  handleToggleManageMode: () => void;
  handleSelectAllContacts: () => void;
  handleRemoveSelectedContacts: () => void;
  handleDeselectAllContacts: () => void;
  isManageModeEnabled: boolean;
  selectedContactsAmount: number;
  totalContactsAmount: number;
};

export const CreateCustomerContactsManagementControls: FC<CreateCustomerContactsManagementControlsProps> = ({
  isManageModeEnabled,
  selectedContactsAmount,
  totalContactsAmount,
  handleAddContact,
  handleToggleManageMode,
  handleSelectAllContacts,
  handleRemoveSelectedContacts,
  handleDeselectAllContacts,
}) => {
  const isAnySelectedContacts = selectedContactsAmount > 0;
  const isAnyContactsExist = totalContactsAmount > 0;
  const isAllContactsSelected = selectedContactsAmount === totalContactsAmount;

  return (
    <Stack>
      <Typography
        sx={{
          fontSize: 16,
          color: '#020F20'
        }}>
        <Button
          {...getSelectorAttribute(createCustomerPageSelectors.companyDetails.addContact)}
          startIcon={<AddIcon fill="#000" />}
          onClick={handleAddContact}
          sx={{ color: '#000 !important' }}
        >
          Add Contact
        </Button>

        {isManageModeEnabled && <Button onClick={handleToggleManageMode}>Done</Button>}

        {isAnyContactsExist && (
          <>
            {isManageModeEnabled ? (
              <Button onClick={isAllContactsSelected ? handleDeselectAllContacts : handleSelectAllContacts}>
                {isAllContactsSelected ? 'Deselect all' : 'Select all'}
              </Button>
            ) : (
              <Button startIcon={<Pen />} onClick={handleToggleManageMode} sx={{ color: '#000 !important' }}>
                Manage contacts
              </Button>
            )}
          </>
        )}

        {isManageModeEnabled && isAnySelectedContacts && (
          <Button startIcon={<VyIcon icon="Truncate" />} onClick={handleRemoveSelectedContacts}>
            Delete {selectedContactsAmount} contacts
          </Button>
        )}
      </Typography>
    </Stack>
  );
};
